import React from "react";
import './AccountSettingsTab_Bracket.css';
import AccountInfoScreenCard from "./AccountInfoScreenCard";
import { updateAccount } from "utilities/js/callouts/CalloutFactory";
import InputBox from "components/reusable/InputBox";


class AccountSettingsTab_Bracket extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            roundSpacing: this.props.userInfo.roundSpacing ? this.props.roundSpacing : true,
            hideByes: this.props.userInfo.hideByes ? this.props.userInfo.hideByes : false,
            label: 'Bracket Settings'
        };

        this.setHideByes = this.setHideByes.bind(this);
        this.setRoundSpacing = this.setRoundSpacing.bind(this); 
        this.setDoubleElim = this.setDoubleElim.bind(this);
    }

    updateAccount(){

        updateAccount({roundSpacing: this.state.roundSpacing, hideByes: this.state.hideByes}).then(response => {
            console.log('Updated account successfully');
            //TODO: Show Toast
        }).catch(error => {
            console.log('cound not update account');
            console.log(error);
        }).finally(() => {

        });
    }

    setHideByes(event){   
        this.props.updateSetting({hideByes: event.currentTarget.checked});
    }

    setRoundSpacing(event){
        this.props.updateSetting({roundSpacing: event.currentTarget.checked});
    }

    setDoubleElim(event){
        this.props.updateSetting({doubleElim: event.currentTarget.checked});
    }

    get hideByesCard(){
        let inputBox = (<InputBox type='checkbox' class="settings-checkbox" disabled value={this.props.userInfo.hideByes}></InputBox>);
        if(this.props.mode === 'edit'){
            inputBox = (<InputBox type='checkbox' class="settings-checkbox" value={this.props.userInfo.hideByes} valueChangedCallback={this.setHideByes}></InputBox>);
        }

        return (<AccountInfoScreenCard 
            emphasis={this.props.mode === 'edit'}
            label="Hide Byes"                 
            content={(<div className="screen-card-subtext">Decide whether or not to hide byes by default in the new brackets you create</div>)}
            actions={inputBox}
        ></AccountInfoScreenCard>);
    }

    get roundSpacingCard(){
        let inputBox = (<InputBox type='checkbox' class="settings-checkbox" disabled value={this.props.userInfo.roundSpacing}></InputBox>);
        if(this.props.mode === 'edit'){
            inputBox = (<InputBox type='checkbox' class="settings-checkbox" value={this.props.userInfo.roundSpacing} valueChangedCallback={this.setRoundSpacing}></InputBox>);
        }

        return (
            <AccountInfoScreenCard 
                emphasis={this.props.mode === 'edit'}
                label="Round Spacing" 
                content={(<div className="screen-card-subtext">Decide whether or not you want each spacing between rounds by default</div>)}
                actions={inputBox}
            ></AccountInfoScreenCard>  
        );
    }

    get doubleElimDefaultCard(){
        let inputBox = (<InputBox type='checkbox' class="settings-checkbox" disabled value={this.props.userInfo.doubleElim}></InputBox>);
        if(this.props.mode === 'edit'){
            inputBox = (<InputBox type='checkbox' class="settings-checkbox" value={this.props.userInfo.doubleElim} valueChangedCallback={this.setDoubleElim}></InputBox>);
        }

        return (
            <AccountInfoScreenCard 
                emphasis={this.props.mode === 'edit'}
                label="Double Elimination by Default" 
                content={(<div className="screen-card-subtext">Decide whether or not you want to turn on double elimination by default when creating new brackets</div>)}
                actions={inputBox}
            ></AccountInfoScreenCard>  
        );
    }
    


    render(){

        return (
            <>
            <div className="account-info-label hide-desktop">{this.state.label}</div>
            {this.hideByesCard}
            {this.roundSpacingCard}    
            {this.doubleElimDefaultCard}             
            </>
        );
    }
}

export default AccountSettingsTab_Bracket;
